import {api, routes} from "@/plugins/axios";


export function useGroups() {

    const createGroup = (organizationSlug, data) => {
        const formData = new FormData();
        formData.append('name', data.name);

        if (data.description) {
            formData.append('description', data.description);
        }

        return api.post(routes.groups.create(organizationSlug), formData)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };

    const getGroups = (organizationSlug,  page = 1, perPage = 10, search = '') => {
        return api.get(routes.groups.get(organizationSlug, page, perPage, search))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const deleteGroup = (organizationSlug, groupUid) => {
        return api.delete(routes.groups.delete(organizationSlug, groupUid))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const deleteChatGroup = (organizationSlug, groupUid) => {
        return api.delete(routes.groups.deleteChatGroup(organizationSlug, groupUid))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const associateMembers = (organizationSlug, groupUid, members) => {
        return api.patch(routes.groups.associateMembers(organizationSlug, groupUid), members)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };

    const disassociateMembers = (organizationSlug, groupUid, members) => {
        return api.post(routes.groups.disassociateMembers(organizationSlug, groupUid), members)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const getGroup = (organizationSlug, groupUid) => {
        return api.get(routes.groups.show(organizationSlug, groupUid))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const updateGroup = (organizationSlug, groupUid, data) => {
        return api.patch(routes.groups.update(organizationSlug, groupUid), data)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const uploadAvatar = (organizationSlug, groupUid, groupAvatar) => {
        const formData = new FormData();
        formData.append('avatar', groupAvatar);

        return api.post(routes.groups.avatar.store(organizationSlug, groupUid), formData).catch((err) => {
            return Promise.reject(err);
        });
    }

    const deleteAvatar = (organizationSlug, groupUid) => {
        return api.delete(routes.groups.avatar.delete(organizationSlug, groupUid)).catch((err) => {
            return Promise.reject(err);
        });
    }

    return {
        createGroup,
        getGroup,
        getGroups,
        deleteGroup,
        deleteChatGroup,
        associateMembers,
        disassociateMembers,
        updateGroup,
        uploadAvatar,
        deleteAvatar
    }
}
